'use strict';

var tslib_es6 = require('./tslib.es6-fe93d37b.js');

var parseTime = function (time) {
    var _a = tslib_es6.__read(time.split(':'), 2), hourString = _a[0], minuteString = _a[1];
    return [parseInt(hourString, 10), parseInt(minuteString, 10)];
};

exports.parseTime = parseTime;
